module.exports = __webpack_public_path__ + "static/media/service2.bb109dd7.jpg";